export const COORDINATES_DATA = 'COORDINATES_DATA';